if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));

    // Cookie settings handler
    const allLinks = document.querySelectorAll("a");
    allLinks.forEach((link) => {
      if (
        link.textContent.includes("Cookie Einstellungen") ||
        (link.href && link.href.includes("cookie-settings"))
      ) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          if (window?.UC_UI) {
            window.UC_UI.showSecondLayer();
          }
        });
      }
    });

    // Express Checkout button handler with repeated checks
    let checkCount = 0;
    const maxChecks = 5;
    const checkInterval = 500; // Check every 500ms

    function checkForButton() {
      const moreOptionsLink = document.querySelector(
        ".shopify-payment-button__more-options"
      );
      if (moreOptionsLink) {
        // Update the button's appearance
        moreOptionsLink.textContent = "SICHER ZUR BEZAHLUNG";
        moreOptionsLink.classList.add("btn", "btn--full");
        console.log("Express Checkout button updated");
      }

      checkCount++;
      if (checkCount < maxChecks) {
        // Continue checking regardless of whether we found the button
        setTimeout(checkForButton, checkInterval);
      } else {
        console.log("Express Checkout button checks completed");
      }
    }

    // Start the first check
    checkForButton();

    // German sorting translations
    const isGermanLocale =
      window.locale &&
      (window.locale.iso_code === "de" || window.locale.default);

    if (isGermanLocale) {
      const sortDropdown = document.getElementById("SortBy");
      if (sortDropdown) {
        const translations = {
          "best-selling": "Meistverkauft",
          "title-ascending": "Alphabetisch, A-Z",
          "title-descending": "Alphabetisch, Z-A",
          "price-ascending": "Preis aufsteigend",
          "price-descending": "Preis absteigend",
          "created-ascending": "Älteste zuerst",
          "created-descending": "Neuste zuerst",
        };

        Array.from(sortDropdown.options).forEach((option) => {
          if (translations[option.value]) {
            option.text = translations[option.value];
          }
        });
      }
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  console.log("GCLID tracking script initialized");
  
  // Check if there's a gclid in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const gclid = urlParams.get("gclid");
  
  console.log("URL parameters:", window.location.search);
  console.log("GCLID found in URL:", gclid);
  
  // If gclid exists, add it to cart attributes
  if (gclid) {
    console.log("Attempting to save GCLID to cart attributes:", gclid);
    
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          gclid: gclid,
        },
      }),
    })
    .then(response => response.json())
    .then(data => {
      console.log("Cart update successful:", data);
      console.log("GCLID saved to cart attributes");
    })
    .catch(error => {
      console.error("Error updating cart with GCLID:", error);
    });
  } else {
    console.log("No GCLID parameter found in URL");
  }
});


var getChatboxElement;
var chatboxCounter = 0;
var _maxAttempts = 20;
var documentListenerAdded = false;
var storedShadowRoot = null;
var storedToggleButton = null;
var headingUpdateInProgress = false;

function updateInboxChatLabel() {
  if (getChatboxElement) {
    clearInterval(getChatboxElement);
    getChatboxElement = null;
  }

  if (headingUpdateInProgress) {
    headingUpdateInProgress = false;
  }

  const shopify_chat = document.querySelector('#shopify-chat');
  if (!shopify_chat) {
    if (chatboxCounter >= _maxAttempts) {
      return;
    }
    chatboxCounter++;
    getChatboxElement = setInterval(updateInboxChatLabel, 500);
    return;
  }

  const inbox_online_store_chat = shopify_chat.querySelector('inbox-online-store-chat');
  if (!inbox_online_store_chat) {
    
    if (chatboxCounter >= _maxAttempts) {
      return;
    }
    chatboxCounter++;
    getChatboxElement = setInterval(updateInboxChatLabel, 300);
    return;
  }

  const innerShadowRoot = inbox_online_store_chat.shadowRoot;
  if (!innerShadowRoot) {
    
    if (chatboxCounter >= _maxAttempts) {
      return;
    }
    chatboxCounter++;
    getChatboxElement = setInterval(updateInboxChatLabel, 200);
    return;
  }

  
  if (!storedShadowRoot) {
    storedShadowRoot = innerShadowRoot;
  }

  
  const button_text = innerShadowRoot.querySelector('.chat-title');
  const store_info_heading = innerShadowRoot.querySelector('.store-info-heading');
  
  const hasTargetElements = button_text || store_info_heading;
  if (hasTargetElements) {
    
    if (button_text) {
      if(window.inbox_chat_app.chat_label !='' || window.inbox_chat_app.chat_label != null) button_text.textContent = window.inbox_chat_app.chat_label;
    }
    if (store_info_heading) {
      const innerHeading = store_info_heading.querySelector('h2');
      if (innerHeading) {
        if(window.inbox_chat_app.chat_popup_heading != '' || window.inbox_chat_app.chat_popup_heading != null) innerHeading.textContent = window.inbox_chat_app.chat_popup_heading;
      }
    }
    if (!storedToggleButton) {
      storedToggleButton = innerShadowRoot.querySelector('.chat-app')?.querySelector('button');
    }

    if (!documentListenerAdded && storedToggleButton) {
      document.addEventListener('click', (event) => {
        if (event.target == inbox_online_store_chat) {
          
          let headingFound = false;
          
          if (storedShadowRoot) {
            const currentButtonText = storedShadowRoot.querySelector('.chat-title');
            if (currentButtonText) {
              if(window.inbox_chat_app.chat_label !='' || window.inbox_chat_app.chat_label != null) currentButtonText.textContent = window.inbox_chat_app.chat_label;
            }
            
            const currentStoreInfoHeading = storedShadowRoot.querySelector('.store-info-heading');
            if (currentStoreInfoHeading) {
              const innerHeading = currentStoreInfoHeading.querySelector('h2');
              if (innerHeading) {
                if(window.inbox_chat_app.chat_popup_heading != '' || window.inbox_chat_app.chat_popup_heading != null) innerHeading.textContent = window.inbox_chat_app.chat_popup_heading;
              }
              headingFound = true;
            }
          }
          
          if (!headingFound && !headingUpdateInProgress) {
            headingUpdateInProgress = true;
            updateInboxChatLabel();
          }
        }
      });
      documentListenerAdded = true;
    }

    chatboxCounter = 0;
    return;
  }

  if (chatboxCounter >= _maxAttempts) {
    return;
  }
  chatboxCounter++;
  getChatboxElement = setInterval(updateInboxChatLabel, 100);
}

// Start the initial poll
getChatboxElement = setInterval(updateInboxChatLabel, 500);



